import { render, staticRenderFns } from "./EditStyleSelectColor.vue?vue&type=template&id=13eced12&scoped=true&"
import script from "./EditStyleSelectColor.vue?vue&type=script&lang=js&"
export * from "./EditStyleSelectColor.vue?vue&type=script&lang=js&"
import style0 from "./EditStyleSelectColor.vue?vue&type=style&index=0&id=13eced12&lang=scss&scoped=true&"
import style1 from "./EditStyleSelectColor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13eced12",
  null
  
)

export default component.exports